module.exports = __webpack_public_path__ + "static/media/logo.e74d2999.svg";


//////////////////
// WEBPACK FOOTER
// ./src/reusable/images/logo.svg
// module id = 969
// module chunks = 0